<template>
    <v-layout class="rounded rounded-md border">
        <v-navigation-drawer
            v-model="drawer"
            :location="$vuetify.display.mobile ? 'bottom' : undefined"
            :expand-on-hover="!$vuetify.display.mobile"
            :rail="!$vuetify.display.mobile"
        >
            <div class="flex flex-col h-full">
                <v-list>
                    <v-list-item
                        :prepend-avatar="logo"
                        :title="authStore.user?.name"
                        :subtitle="authStore.user?.email"
                    >
                        <template v-slot:append>
                            <v-menu offset-y>
                                <template v-slot:activator="{ props }">
                                    <v-btn
                                        icon="mdi-menu-down"
                                        size="small"
                                        variant="text"
                                        v-bind="props"
                                    ></v-btn>
                                </template>
                                <v-list>
                                    <v-list-item>
                                        <v-list-item-title>
                                            <v-btn color="red" density="comfortable" prepend-icon="mdi-logout"
                                                   @click="logout">
                                                Вийти
                                            </v-btn>
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </template>
                    </v-list-item>
                </v-list>

                <v-divider></v-divider>

                <v-list class="grow" :lines="false" density="compact" nav>
                    <v-list-item
                        v-for="(item, i) in items"
                        :key="i"
                        :value="item"
                        color="primary"
                        :to="item?.to || ''"
                    >
                        <template v-slot:prepend>
                            <v-icon :icon="item.icon"></v-icon>
                        </template>

                        <v-list-item-title>
                            {{ item.text }}
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
                <!--                <div class="!px-4">-->
                <!--                    <v-select-->
                <!--                        :items="['store 1', 'store 2']"-->
                <!--                        label="Магазин"-->
                <!--                        item-title="name"-->
                <!--                        item-value="id"-->
                <!--                        density="compact"-->
                <!--                        variant="outlined"-->
                <!--                    />-->
                <!--                </div>-->
            </div>
        </v-navigation-drawer>

        <v-app-bar color="primary">
            <v-app-bar-nav-icon
                variant="text"
                @click.stop="drawer = !drawer"
            ></v-app-bar-nav-icon>

            <v-toolbar-title>
                <v-breadcrumbs :items="breacrumbs" class="text-base">
                    <template v-slot:divider>
                        <v-icon icon="mdi-chevron-right"></v-icon>
                    </template>
                </v-breadcrumbs>
            </v-toolbar-title>
            <v-card-title>{{ authStore?.user?.shop?.name }}</v-card-title>
        </v-app-bar>

        <v-main class="d-flex align-center justify-center">
            <slot/>
        </v-main>
    </v-layout>
</template>

<script setup>
import {ref, watch, computed, onMounted} from "vue";
import {useRoute, useRouter} from "vue-router";
import {useSnackbarStore} from '@/js/stores/snackbarStore'
import {logout as logoutApi} from '../api';
import logo from "@/assets/img/logo.jpg";
import {usePaymentMethodsStore} from "../stores/paymentMethodsStore.js";
import {useBrandsStore} from "../stores/brandsStore.js";
import {useSizeStore} from "../stores/sizeStore.js";
import {useColorStore} from "../stores/colorStore.js";
import {useOrderStore} from "../stores/orderStore.js";

const route = useRoute();
const router = useRouter();
const paymentMethodsStore = usePaymentMethodsStore();
const brandsStore = useBrandsStore();
const colorStore = useColorStore();
const sizeStore = useSizeStore();
const orderStore = useOrderStore();

const pageTitle = computed(() => (typeof route.meta.title === 'function'
    ? route.meta.title(route)
    : route.meta.title) || "BrandRoom");


const breacrumbs = computed(() => {
    if (route.meta.breadcrumb) {
        return route.meta.breadcrumb.map(item => {
            return {
                title: typeof item.name === 'function' ? item.name(route) : item.name,
                href: item.to ? router.resolve(item.to).href : undefined,
                disabled: !item.to
            }
        })
    }
    const currentTitle = typeof route.meta.title === 'function'
        ? route.meta.title(route)
        : route.meta.title;
    if (currentTitle) {
        return [
            {
                title: currentTitle,
                href: undefined,
                disabled: true
            }
        ]
    }
    return []
})


import {useAuthStore} from "../stores/authStore.js";

const snackbar = useSnackbarStore()
const authStore = useAuthStore();
const drawer = ref(true);
const group = ref(null);
const items = [
    // {text: "Dashboard", icon: "mdi-view-dashboard", to: "/"},
    {text: "Замовлення", icon: "mdi-cart-outline", to: "/orders"},
    {text: "Відправки бренду", icon: "mdi-repeat", to: "/brand-returns"},
    {text: "Товари", icon: "mdi-storefront", to: "/products"},
    {text: "Звіт", icon: "mdi-apps", to: "/reports"},
];

async function logout() {
    try {
        await logoutApi();
        authStore.logout();
        snackbar.notify({
            text: 'Успішно!',
            color: 'success'
        })
        setTimeout(() => {
            router.push({name: 'Login'});
        }, 500);

    } catch (error) {
        snackbar.notify({
            text: 'Виникла помилка!',
            color: 'error'
        })
        console.error('Logout failed:', error.message || 'Виникла помилка.');
    }
}

watch(group, () => {
    drawer.value = false;
});

onMounted(async () => {
    if (authStore.isAuthenticated) {
        await paymentMethodsStore.fetchPaymentMethods();
        await brandsStore.fetchBrands();
        await sizeStore.fetchSizes();
        await colorStore.fetchColors();
        await orderStore.fetchOrderTypes();
    }

})
</script>
